import { getStoreBuilder } from 'vuex-typex';
import { RootState } from '..';

export enum Action {
    join = "join",
    playerJoined = "playerJoined",
    playerLeft = "playerLeft",
    start = "start",
    gameStarted = "gameStarted",
    nextTurn = "nextTurn",
    accuse = "accuse",
    getInformantCard = "getInformantCard",
    getWitnessInfo = "getWitnessInfo",
    getPlayerGlass = "getPlayerGlass"
};

export type CardId = string;

export type Player = {
    id: string,
    name: string
}

export type PlayerId = string;

export enum CardCategory {
    Person = "Person",
    Location = "Location",
    Weapon = "Weapon"
}

export type Card = {
    category: CardCategory,
    type: "A" | "B",
    number: number //indica anche il colore
};

type StateWitnessInfo = {
    witnessId: PlayerId,
    matchingCardsCount: number,
    question: Question
}

type StateInformantCard = {
    cardIndex: number,
    playerWithoutGlasses: PlayerId | undefined,
    informantCard?: Card
}

type StateAccuse = {
    cards: Card[],
    correct: boolean,
    playerWithoutGlasses: PlayerId | undefined,
}

export type GameState = {
    gid: string,
    turn: number,
    playerLeft: PlayerId | undefined,
    players: Player[],
    playerInfo: Player,
    isOwner: boolean,
    gameStarted: boolean,
    gameEnded: boolean,
    allDeckCards: (Card & { src: string })[],
    currentPlayerId: PlayerId;
    winner: PlayerId | undefined,
    sortedPlayers: Player[],
    playersPublicCards: {
        [playerId: string]: Card[]
    },
    secretCards: Card[],
    playersGlasses: {
        [playerId: string]: number
    },
    tableCards: number,
    tableGlasses: number,
    gameLog: string,
    witnessInfo: StateWitnessInfo | undefined,
    informantCard: StateInformantCard | undefined,
    accuse: StateAccuse | undefined,
    ui: {
        showActionDlg: boolean,
        showChooseQuestionDlg: boolean,
        witnessId: PlayerId | undefined,
        actionMode: ActionMode,
        showInformantDlg: boolean,
        informantCardIndex: number | undefined,
        showAccuseDlg: boolean,
        gotGlassFromTable: boolean,
        showNeedGlassDlg: boolean,
        showConfirmTakeGlassDlg: boolean,
        glassPlayerId: PlayerId | undefined,
        needGlass: boolean
    }
};

export type CategoryQuestion = {
    category: CardCategory,
    type: "A" | "B"
}
export type ColorQuestion = {
    color: number
}

export const Colors = [
    "VIOLA",
    "ROSA",
    "ROSSO",
    "VERDE",
    "GIALLO",
    "BLU",
    "ARANCIONE",
    "BIANCO",
    "MARRONE",
    "GRIGIO"
]

export enum ActionMode {
    none,
    QuestionWitness,
    ConsultInformant,
    Accuse
}

export type Question = CategoryQuestion | ColorQuestion;

export function isColorQuestion(q: CategoryQuestion | ColorQuestion): q is ColorQuestion {
    return (<ColorQuestion>q).color != undefined;
}

const initialState: GameState = {
    gid: "",
    turn: -1,
    players: [],
    playerLeft: undefined,
    playerInfo: {} as Player,
    isOwner: false,
    gameStarted: false,
    gameEnded: false,
    allDeckCards: [],
    currentPlayerId: "",
    winner: "",
    sortedPlayers: [],
    playersPublicCards: {
    },
    secretCards: [],
    playersGlasses: {},
    tableCards: 0,
    tableGlasses: 0,
    gameLog: "",
    witnessInfo: undefined,
    informantCard: undefined,
    accuse: undefined,
    ui: {
        showActionDlg: false,
        showChooseQuestionDlg: false,
        witnessId: undefined,
        actionMode: ActionMode.none,
        showInformantDlg: false,
        informantCardIndex: undefined,
        showAccuseDlg: false,
        gotGlassFromTable: false,
        showNeedGlassDlg: false,
        showConfirmTakeGlassDlg: false,
        glassPlayerId: undefined,
        needGlass: false
    }
}

export const builder = getStoreBuilder<RootState>().module("game", initialState);